import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { Order } from '../../api/api-generated';
import { useUpdateOrderMutation } from '../../api/api-hooks';

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  order: Order;
}
export const CompleteOrderDialog = ({
  dialogOpen,
  setDialogOpen,
  order,
}: Props) => {
  const [updateOrder] = useUpdateOrderMutation();
  const handleCancel = () => {
    setDialogOpen(false);
  };
  const handleConfirm = () => {
    updateOrder({
      id: order.id,
      updateOrderDto: {
        id: order.id,
        completed: true,
      },
    });
    setDialogOpen(false);
  };
  return (
    <Dialog
      fullWidth
      maxWidth='xs'
      open={dialogOpen}
      aria-labelledby='form-dialog-title'
    >
      <DialogTitle>Complete Order</DialogTitle>
      <DialogContent>
        Are you sure you want to mark this order as complete?
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={handleConfirm}>
          Yes
        </Button>
        <Button color='error' onClick={handleCancel}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};
